// extracted by mini-css-extract-plugin
export var chevronIcon = "_df-2";
export var teamName = "_df-1";
export var teamSwitcherButton = "_df-0";